import type { EmailAccountSmtpLogin, ProvisionedEmailAccount, SmtpLoginStatus } from "../../../api/emailAccountsTypes";

interface SmtpSettingRow {
  label: string;
  value: string;
}

export type ProvisionedSmtpAccount = Required<ProvisionedEmailAccount>;

export const hasSmtpSettings = (account: ProvisionedEmailAccount): account is ProvisionedSmtpAccount =>
  !!account.smtpHost && typeof account.smtpPort === "number" && !!account.password;

export const getSmtpLoginStatus = (
  smtpLogins: EmailAccountSmtpLogin[] | undefined,
  hasLoadFailed: boolean,
  accountId: string
): SmtpLoginStatus | undefined => {
  if (hasLoadFailed) {
    return "Unknown";
  }

  if (smtpLogins === undefined) {
    return undefined;
  }

  return smtpLogins.find((login) => login.accountId === accountId)?.status ?? "Unknown";
};

export const getSmtpSettingRows = (account: ProvisionedSmtpAccount): SmtpSettingRow[] => [
  { label: "Account name", value: account.displayName },
  { label: "Email address", value: account.address },
  { label: "SMTP server", value: account.smtpHost },
  { label: "Port", value: account.smtpPort.toString() },
  { label: "Password", value: account.password },
];
